/**
 * Solanaland
 *
 * Author: Phia Nasol
 * Company: Digiteer Inc.
 *
 * https://www.digiteer.digital/
 *
 */

import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { api } from "core/api";
import { Table, SvgIcon } from "core/components";
import { edit_admin_project_path, project_allocation_admin_item_inventory_path } from "routes";

type ItemInventoryProjectAllocationProps = {
  inventory_item: Record<string, unknown>;
};

const ItemInventoryProjectAllocation = ({ inventory_item, warehouse_id }: ItemInventoryProjectAllocationProps): JSX.Element => {
  const [projectAllocations, setProjectAllocations] = React.useState([]);
  const table = React.useRef(null);
  const columns = React.useMemo(
    () => [
      {
        id: "id",
        Header: "Id",
        accessor: "id"
      },
      {
        id: 1,
        Header: "Project ID",
        accessor: "project.code",
        Cell: (props) => {
          return (
            <div title={props.value} data-bs-toggle="tooltip">
              <p className="text-truncate text-center">{props.value}</p>
            </div>
          );
        }
      },
      {
        Header: "Allocated Quantity",
        accessor: "reserved_quantity",
        Cell: (props) => {
          return (
            <div title={props.value} data-bs-toggle="tooltip">
              <p className="text-truncate text-center">{props.value}</p>
            </div>
          );
        }
      },
      {
        Header: "Action",
        accessor: "",
        Cell: (props) => {
          return (
            <div className="d-flex justify-content-center">
              <a
                className="button button--action button--action-approve"
                title="View Project"
                data-bs-toggle="tooltip"
                onClick={() => {
                  window.open(edit_admin_project_path(props.row.original.project.id));
                }}
              >
                <SvgIcon name="view" className="h5" />
              </a>
            </div>
          );
        }
      }
    ],
    []
  );

  const getItemInventory = async (id) => {
    try {
      const response = await api.get(project_allocation_admin_item_inventory_path(id, warehouse_id || -1));
      setProjectAllocations(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  React.useEffect(() => {
    getItemInventory(inventory_item.id).catch(console.error);
  }, []);

  return (
    <React.StrictMode>
      {projectAllocations.length > 0 ? (
        <Table columns={columns} data={projectAllocations} ref={table} />
      ) : (
        <Container>
          <Row className="text-center">
            <Col>{`No project allocation.`}</Col>
          </Row>
        </Container>
      )}
    </React.StrictMode>
  );
};

export default ItemInventoryProjectAllocation;
